import moment from 'moment'

export const sizeConverter = (size) => {
  if (size.toString().length > 6) {
    return `${Math.ceil(size / 1000000)} MB`
  } else {
    return `${Math.ceil(size / 1000)} KB`
  }
}
export const calculateTax = (price) => {
  if (price) {
    return price * (10 / 100)
  }
  return 0
}

export const displayCampaignStatus = (status) => {
  let value = status
  if (status.toLowerCase() == 'waiting for approval') {
    value = 'waiting approval'
  } else if (status.toLowerCase() == 'waiting for payment') {
    value = 'waiting payment'
  }

  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const displayPaymentStatus = (status) => {
  let value = status.toLowerCase()
  let res = []
  switch(value){
    case `pending`:
      res = { id: 0, value: 'pending', label: 'PENDING', status: 'pending'}
      break
    case `afterpay`:
      res = { id: 1, value: 'afterpay', label: 'AFTERPAY', status: 'afterpay'}
      break
    case `paid`:
      res = { id: 2, value: 'paid', label: 'PAID', status: 'paid'}
      break
    case `downpayment`:
      res = { id: 3, value: 'downpayment', label: 'DOWNPAYMENT', status: 'downpayment'}
      break
    case `partially`:
      res = { id: 4, value: 'partially', label: 'PARTIALLY', status: 'partially'}
  }
  return res
}

export const displayLabelStatus = (status) => {
  let value = status.toLowerCase()
  let res = []
    switch(value){
      case `draft`:
        res = { id: 0, value: 'draft', label: 'DRAFT'}
        break
      case `verifying`:
        res = { id: 1, value: 'verifying', label: 'VERIFYING'}
        break
      case `active`:
        res = { id: 2, value: 'active', label: 'ACTIVE'}
        break
      case `expired`:
        res = { id: 3, value: 'expired', label: 'EXPIRED'}
        break
      case `cancel`:
        res = { id: 4, value: 'cancel', label: 'CANCELED'}
        break
      case `dormant`:
        res = { id: 5, value: 'dormant', label: 'DORMANT'}
        break
      case `upcoming`:
        res = { id: 4, value: 'upcoming', label: 'UPCOMING',}
    }
    return res
}

export const formatShortDate = (date) => {
  var retval = new Date(date);
  var options = { year: 'numeric', month: 'short', day: '2-digit' };
  return retval.toLocaleDateString("en-GB", options)
}
export const formatShortDateTime = (date) => {
  var retval = new Date(date);
  var options = { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit'  };
  return retval.toLocaleDateString("en-GB", options)
}
export const formatLongDate = (date) => {
  var retval = new Date(date);
  var options = { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit' };
  return retval.toLocaleDateString("en-GB", options)
}
export const formatFullDate = (date) => {
  var retval = new Date(date);
  var options = { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit' };
  return retval.toLocaleDateString("en-GB", options)
}
export const formatShortMonthYear = (date) => {
  var retval = new Date(date);
  var options = { year: 'numeric', month: 'short' };
  return retval.toLocaleDateString("en-GB", options)
}

export const dateFormat = (formatInput, formatOutput, date) => {
  return moment(date, formatInput).format(formatOutput)
}

let lib = {
  sizeConverter,
  calculateTax,
  formatShortDate,
  formatLongDate,
  formatFullDate,
  dateFormat,
  displayCampaignStatus,
  displayLabelStatus,
  displayPaymentStatus,
  formatShortMonthYear
}
export default lib
